import { render } from "./Dropzone.vue?vue&type=template&id=ad41c432"
import script from "./Dropzone.vue?vue&type=script&lang=js"
export * from "./Dropzone.vue?vue&type=script&lang=js"
script.render = render

export default script